import { nextArrow, prevArrow, options } from "@/global/slick-options";

jQuery( '.single-gallery-main' ).slick( {
    ...options,
    slidesToShow: 1,
    arrows: false,
    fade: true,
    asNavFor: '.single-gallery-nav'
} );

jQuery( '.single-gallery-nav' ).slick( {
    ...options,
    slidesToShow: 3,
    asNavFor: '.single-gallery-main',
    rows: 0,
    centerMode: true,
    centerPadding: '0',
    infinite: true,
} );
